export class ThesisOrderModel {
  accessToken: string;
  basePrice: number;
  comment: string;
  discountPercentage: number;
  discountPrice: number;
  fileMetadata: any;
  finalPrice: number;
  gwurl: string;
  id?: number;
  isPaidByPromoCode: boolean;
  notificationEmailSentDatetime: Date;
  originalitySentDatetime: Date;
  originalityVerificationDatetime: Date;
  payerEmail: string;
  payerLogin: string;
  payerName: string;
  payerUniversity: string;
  paymentId: number;
  percentOfMatch: number;
  promoCode: string;
  status: number;
  thesisId: number;
  type: number;
  userId: number;
}
